<mat-card>
  <form name="organisationForm" [formGroup]="form">
    <h3>What is your event called and when is it on?</h3>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <input matInput required formControlName="name" name="event_name" (focusout)="trimValue($event,'name')" />
          <mat-label>Event Name</mat-label>
          <mat-hint>The name of the event as it should appear on the listing.</mat-hint>
          <mat-error *ngIf="form.get('name').invalid">{{getErrorMessage('name')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-select matInput [(value)]="value.eventType" formControlName="eventType" name="event_eventType">
            <mat-option value="Festival">Festival</mat-option>
            <mat-option value="Event">Event</mat-option>
            <mat-option value="Market">Market</mat-option>
          </mat-select>
          <mat-label>Event Type</mat-label>
          <mat-hint>Specify the type of event you are organising.</mat-hint>
        </mat-form-field>
      </div>
      <!-- <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-select matInput [(value)]="value.category" formControlName="category" name="event_category" multiple>
            <mat-option value="ComedyEvent">Comedy</mat-option>
            <mat-option value="ChildrensEvent">Children's</mat-option>
            <mat-option value="DanceEvent">Dance</mat-option>
            <mat-option value="ExhibitionEvent">Exhibitions</mat-option>
            <mat-option value="FoodEvent">Food</mat-option>
            <mat-option value="EducationEvent">Education</mat-option>
            <mat-option value="LiteraryEvent">Literary</mat-option>
            <mat-option value="MusicEvent">Music</mat-option>
            <mat-option value="SportsEvent">Sport and Outdoors</mat-option>
            <mat-option value="TheaterEvent">Theatre</mat-option>
            <mat-option value="VisualArtsEvent">Visual Arts</mat-option>
          </mat-select>
          <mat-label>Category</mat-label>
          <mat-hint>Specify the categories so we know where this event should be listed.</mat-hint>
        </mat-form-field>
      </div> -->
    </div>
    <!-- <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-select matInput formControlName="occurrenceType" (selectionChange)="setOccurrenceType($event.value)"
            name="event_occurrence">
            <mat-option value="OnceOff">Occurs over one day</mat-option>
            <mat-option value="SpecificDates">Occurs over multiple days</mat-option>
          </mat-select>
          <mat-label>Occurrence</mat-label>
          <mat-hint>Is this date a once off or does it occur over a few days? </mat-hint>
        </mat-form-field>
      </div> -->
    <!-- <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-select matInput formControlName="frequency" name="event_frequency" (selectionChange)="setFrequency($event.value)">
            <mat-option value="OnceOff">Once Off</mat-option>
            <mat-option value="Weekly">Weekly</mat-option>
            <mat-option value="Monthly">Monthly</mat-option>
            <mat-option value="Annually">Annually</mat-option>
          </mat-select>
          <mat-label>Frequency</mat-label>
          <mat-hint>Is this event occurring multiple times or once off? </mat-hint>
        </mat-form-field>
      </div> -->
    <!-- <div class="col-md-12 col-lg-6" *ngIf="value.frequency=='Weekly' || value.frequency=='TwoWeeks'">
          <mat-form-field appearance="outline">
            <mat-label>Days of Week</mat-label>
            <mat-select  matInput formControlName="daysOfWeek" name="event_daysOfWeek" multiple>
              <mat-option value="Monday">Monday</mat-option>
              <mat-option value="Tuesday">Tuesday</mat-option>
              <mat-option value="Wednesday">Wednesday</mat-option>
              <mat-option value="Thursday">Thursday</mat-option>
              <mat-option value="Friday">Friday</mat-option>
              <mat-option value="Saturday">Saturday</mat-option>
              <mat-option value="Sunday">Sunday</mat-option>
            </mat-select>
            <mat-hint>Is this event occurring multiple times or once off? </mat-hint>
          </mat-form-field>
        </div> -->
    <!-- <div class="col-lg-6 col-md-12 col-sm-12">
        <mat-form-field appearance="outline" *ngIf="value.occurrenceType=='OnceOff'">
          <input matInput [matDatepicker]="onceOffDatePicker" [min]="minDate" formControlName="onceOffDate"
            name="event_onceoff_date">
          <mat-label>Date of Event</mat-label>
          <mat-hint>What date is this event on?</mat-hint>
          <mat-error *ngIf="form.get('onceOffDate').invalid">{{getErrorMessage('onceOffDate')}}</mat-error>
          <mat-datepicker-toggle matSuffix [for]="onceOffDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #onceOffDatePicker></mat-datepicker>
        </mat-form-field>
      </div> -->
    <!-- </div> -->
    <!-- <div class="row" *ngIf="value.occurrenceType=='SpecificDates'"> -->
    <div class="row" style="margin-bottom: 30px; margin-top: 30px;">
      <div class="col-md-12">
        <h5>Event Dates</h5>
        <app-date-picker [(value)]="value.selectedDates" name="event_eventDates" [parentForm]="form"></app-date-picker>
        <!-- <p class="hint">Please specify the date(s) this event occurs.</p> -->
        <!-- <mat-hint>Please specify the date(s) this event occurs.</mat-hint> -->
        <mat-error *ngIf="form.get('eventDates').invalid">Please specify the date(s) this event occurs.</mat-error>
      </div>
    </div>
    <!-- <div class="row" *ngIf="value.occurrenceType=='OccursBetween'">
      <div class="col-md-12 col-lg-6">
        <mat-form-field appearance="outline">
          <input matInput [matDatepicker]="dateStartPicker" [min]="minDate" formControlName="dateStart"
            name="event_date_start">
          <mat-label>Start Date</mat-label>
          <mat-hint>When does this event start?</mat-hint>
          <mat-error *ngIf="form.get('dateStart').invalid">{{getErrorMessage('dateStart')}}</mat-error>
          <mat-datepicker-toggle matSuffix [for]="dateStartPicker"></mat-datepicker-toggle>
          <mat-datepicker #dateStartPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-md-12 col-lg-6">
        <mat-form-field appearance="outline">
          <input matInput [matDatepicker]="dateEndPicker" formControlName="dateEnd" name="event_date_end">
          <mat-label>End Date</mat-label>
          <mat-hint>What date does this event run until?</mat-hint>
          <mat-error *ngIf="form.get('dateEnd').invalid">{{getErrorMessage('dateEnd')}}</mat-error>
          <mat-datepicker-toggle matSuffix [for]="dateEndPicker"></mat-datepicker-toggle>
          <mat-datepicker #dateEndPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <mat-form-field appearance="outline">
          <input type="time" matInput formControlName="timeStart" name="event_time_start" >
          <mat-label>Start Time</mat-label>
          <mat-hint>What time does this event start at?</mat-hint>
          <mat-error *ngIf="form.get('timeStart').invalid">{{getErrorMessage('timeStart')}}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12 col-lg-6">
        <mat-form-field appearance="outline">
          <input type="time" matInput formControlName="timeEnd" name="event_time_end" >
          <mat-label>End Time</mat-label>
          <mat-hint>What time does this event end at?</mat-hint>
          <mat-error *ngIf="form.get('timeEnd').invalid">{{getErrorMessage('timeEnd')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-card>